import { casesSold } from '../../../../data/product';
import type { Family } from '../data/family';
import { familyTotals } from './family-aggregates';

/**
 * Expected savings if the family's 90-day sales pace continues. Tier price
 * rolls up across the family — projected cases are summed across members
 * before any per-member savings is computed. Reuses `familyTotals` to keep
 * committed and projected math in sync.
 */
export function familyExpectedSavings90d(family: Family): number {
  return familyTotals(family.members, (item) => casesSold(item.product, 90)).savingsDollars;
}

/**
 * Sort families by descending expected 90-day savings, with alphabetical
 * tie-break for stable ordering when scores match (or both are zero).
 */
export function byPriorityDesc(a: Family, b: Family): number {
  const diff = b.expectedSavings90d - a.expectedSavings90d;

  return diff !== 0 ? diff : a.name.localeCompare(b.name);
}
